// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2zdJz","empty":"ModalGraph_empty__1vM3w"};